<template>
  <div id="pagination" class="pagination-wrapper">
    <ul class="pagination-btn-group" v-if="totalElements > 10">
      <button @click="goPrev()" class="pagination-btn before" v-if="currentPage > 1">&lt;</button>
      <button v-for="pageNumber in pageRange(startPage, endPage)" class="pagination-btn" type="button" @click="transParentPage(pageNumber)"
         :class="{active: currentPage === pageNumber}">
        {{pageNumber}}
      </button>
      <button @click="goNext()" v-if="currentPage !== lastPage" class="pagination-btn next">&gt;</button>
    </ul>
  </div>
</template>

<script>
  export default({
    name: 'vue-pagination-template',
    props: ['totalElements', 'currentPage', 'size'],
    data() {
      return {
        perPage: 10,
        url: location.href,
        vars: new Map(),
        numbers: [],
      };
    },
    computed: {
      lastPage() {
        if (this.size) {
          return Math.ceil(this.totalElements / this.size);
        }
        return Math.ceil(this.totalElements / this.perPage);
      },
      startPage() {
        const start = this.currentPage - ((this.currentPage - 1) % 8);
        console.log('this.currentPage', this.currentPage);
        console.log('start', start);
        return start;
      },
      endPage() {
        let totalPage = '';
        if (this.size) {
          totalPage = Math.ceil(this.totalElements / this.size);
        } else {
          totalPage = Math.ceil(this.totalElements / this.perPage);
        }
        let page = this.currentPage - ((this.currentPage - 1) % 8);
        page += 7;
        const lastPage = totalPage > page ? page : totalPage;
        return lastPage;
      },
    },
    methods: {
      pageRange(stat, end) {
        const range = [];
        for (let i = stat; i < end + 1; i += 1) {
          range.push(i);
        }
        return range;
      },
      goPrev() {
        this.$emit('update:currentPage', this.currentPage - 1);
      },
      goNext() {
        this.$emit('update:currentPage', this.currentPage + 1);
      },
      transParentPage(newPageNum) {
        this.$emit('update:currentPage', newPageNum);
      },
    },
  });
</script>



// WEBPACK FOOTER //
// VuePagination.vue?99970090